var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, ButtonList, DropdownButton, Page, SearchInput, SimplePagination, Table, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import * as React from 'react';
import { analytics } from 'app/utils/segment';
import { TableLoadingRow } from 'components/shared/tableLoadingRow';
import TagsCreateModal from 'fable/tagsCreateModal/containers/tagsCreateModal';
import { TagsTableRow } from './tagsTableRow';
const FETCH_DELAY = 1000;
export class Tags extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isCreateModalOpen: false,
            waitingForFetch: false,
        };
    }
    componentDidMount() {
        this.props.tags.getItems();
    }
    setWaitingForFetch(waitingForFetch) {
        this.setState({
            waitingForFetch,
        });
    }
    delayedFetchItems() {
        const { tags } = this.props;
        const { getItems } = tags;
        setTimeout(() => {
            getItems().then(() => {
                this.setWaitingForFetch(false);
            });
        }, FETCH_DELAY);
    }
    handleSearchSubmit(searchTerm) {
        this.props.tags.searchTermChange(searchTerm, 0);
    }
    handleSearchToggle(isOpen) {
        if (!isOpen && this.props.tags.searchTerm) {
            this.props.tags.searchTermChange('', 0);
        }
    }
    handleSortByNameAsc() {
        this.props.tags.sortByChange('name', 'asc');
    }
    handleSortByNameDesc() {
        this.props.tags.sortByChange('name', 'desc');
    }
    handleSortByUsageAsc() {
        this.props.tags.sortByChange('usage_count', 'asc');
    }
    handleSortByUsageDesc() {
        this.props.tags.sortByChange('usage_count', 'desc');
    }
    handleFilterAll() {
        this.props.tags.filterByChange(null);
    }
    handleFilterActive() {
        this.props.tags.filterByChange('active');
    }
    handleFilterDeactivated() {
        this.props.tags.filterByChange('inactive');
    }
    gotoNextPage() {
        this.props.tags.nextPage();
    }
    gotoPreviousPage() {
        this.props.tags.previousPage();
    }
    showCreateModal() {
        analytics.settingsTagsAddTagButtonClicked();
        this.setState({ isCreateModalOpen: true });
    }
    handleCreateModalClose(canceled = false) {
        this.setState({ isCreateModalOpen: false });
        if (!canceled) {
            this.setWaitingForFetch(true);
            this.delayedFetchItems();
        }
    }
    handleRetry() {
        this.props.tags.getItems();
    }
    renderLoadingStatus() {
        const { tags } = this.props;
        if (tags.getItemsAsyncStatus === 'failed') {
            return (_jsx(Table.Tr, { children: _jsxs(Table.Td, { children: ["Something went wrong...", _jsx(Button, Object.assign({ variant: "tertiary", onClick: this.handleRetry }, { children: "Retry" }))] }) }));
        }
        return _jsx(TableLoadingRow, { colSpan: 3 });
    }
    renderSuccessStatus() {
        const { tags } = this.props;
        const { items, toggleActivation } = tags;
        let success;
        if (items.length > 0) {
            success = items.map((tag, i) => (_jsx(TagsTableRow, { tag: tag, toggleActivation: toggleActivation }, i)));
        }
        else {
            success = (_jsx(Table.Tr, { children: _jsx(Table.Td, { children: "No tags found." }) }));
        }
        return success;
    }
    renderFoot() {
        const { tags } = this.props;
        const { hasNextPage, hasPreviousPage, getItemsAsyncStatus } = tags;
        const foot = (_jsx(Table.Tfoot, { children: _jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ colSpan: 5 }, { children: _jsx(SimplePagination, { previousButtonClick: this.gotoPreviousPage, previousButtonDisabled: !hasPreviousPage, nextButtonClick: this.gotoNextPage, nextButtonDisabled: !hasNextPage, loading: getItemsAsyncStatus === 'loading' }) })) }) }));
        return foot;
    }
    render() {
        const { tags } = this.props;
        const { hasNextPage, hasPreviousPage, getItemsAsyncStatus, filterBy } = tags;
        const { waitingForFetch } = this.state;
        const showFoot = hasNextPage || hasPreviousPage;
        return (_jsxs(_Fragment, { children: [_jsx(Page.Section, Object.assign({ title: "All tags", controls: _jsxs(_Fragment, { children: [_jsx(SearchInput, { onSubmit: this.handleSearchSubmit, onToggle: this.handleSearchToggle }), _jsx(DropdownButton, Object.assign({ dropdown: _jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ onClick: this.handleFilterAll, isSelected: filterBy === null }, { children: "All tags" })), _jsx(ButtonList.Item, Object.assign({ onClick: this.handleFilterActive, isSelected: filterBy === 'active' }, { children: "Active tags" })), _jsx(ButtonList.Item, Object.assign({ onClick: this.handleFilterDeactivated, isSelected: filterBy === 'inactive' }, { children: "Deactivated tags" }))] }) }, { children: "Filter" })), _jsx(DropdownButton, Object.assign({ buttonProps: { disabled: !!tags.searchTerm }, dropdown: _jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ icon: "arrow-up", onClick: this.handleSortByNameAsc }, { children: "A - Z" })), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-down", onClick: this.handleSortByNameDesc }, { children: "Z - A" })), _jsx(ButtonList.Divider, {}), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-up", onClick: this.handleSortByUsageDesc }, { children: "Most used" })), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-down", onClick: this.handleSortByUsageAsc }, { children: "Least used" }))] }) }, { children: "Sort by" })), _jsx(Button, Object.assign({ onClick: this.showCreateModal, id: "add-tag-btn" }, { children: "Add tag" }))] }) }, { children: _jsxs(Table, Object.assign({ framed: true, stickyHeader: true, stickyFooter: true, headerWithBackground: true }, { children: [_jsx(Table.Thead, { children: _jsxs(Table.Tr, { children: [_jsx(Table.Th, { children: "Tag" }), _jsx(Table.Th, Object.assign({ width: "20%" }, { children: "Used" })), _jsx(Table.Th, { children: "Active" })] }) }), _jsx(Table.Tbody, { children: !waitingForFetch && getItemsAsyncStatus === 'succeeded'
                                    ? this.renderSuccessStatus()
                                    : this.renderLoadingStatus() }), showFoot && this.renderFoot()] })) })), _jsx(TagsCreateModal, { isOpen: this.state.isCreateModalOpen, onClose: this.handleCreateModalClose })] }));
    }
}
__decorate([
    boundMethod
], Tags.prototype, "handleSearchSubmit", null);
__decorate([
    boundMethod
], Tags.prototype, "handleSearchToggle", null);
__decorate([
    boundMethod
], Tags.prototype, "handleSortByNameAsc", null);
__decorate([
    boundMethod
], Tags.prototype, "handleSortByNameDesc", null);
__decorate([
    boundMethod
], Tags.prototype, "handleSortByUsageAsc", null);
__decorate([
    boundMethod
], Tags.prototype, "handleSortByUsageDesc", null);
__decorate([
    boundMethod
], Tags.prototype, "handleFilterAll", null);
__decorate([
    boundMethod
], Tags.prototype, "handleFilterActive", null);
__decorate([
    boundMethod
], Tags.prototype, "handleFilterDeactivated", null);
__decorate([
    boundMethod
], Tags.prototype, "gotoNextPage", null);
__decorate([
    boundMethod
], Tags.prototype, "gotoPreviousPage", null);
__decorate([
    boundMethod
], Tags.prototype, "showCreateModal", null);
__decorate([
    boundMethod
], Tags.prototype, "handleCreateModalClose", null);
__decorate([
    boundMethod
], Tags.prototype, "handleRetry", null);
